import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20cinematic%20atmosphere%20with%20warm%20golden%20spotlights%20piercing%20through%20deep%20shadows%2C%20abstract%20stage%20curtain%20texture%20with%20soft%20fog%2C%20mysterious%20and%20premium%20vibe%2C%20rich%20dark%20red%20and%20amber%20accents%2C%20clean%20elegant%20composition%2C%20no%20text%20or%20people%2C%20artistic%20minimal%20editorial%20photography%2C%20high%20contrast%2C%20luxurious%20texture&width=1800&height=1000&seq=hero-bg-main-2026&orientation=landscape"
        alt="黑料入口 - 吃瓜黑料入口，每日最新娱乐资讯"
        title="黑料入口 - 黑料吃瓜在线"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center px-4">
        <div className="flex items-center gap-3 mb-6">
          <span className="px-3 py-1 bg-accent-500/90 text-background-50 text-sm font-semibold rounded-full flex items-center gap-1.5">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-fire-fill text-xs"></i>
            </div>
            每日更新
          </span>
          <span className="px-3 py-1 bg-background-50/20 text-background-50 text-sm rounded-full backdrop-blur-sm">
            最新地址已更新
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 text-center max-w-3xl leading-tight">
          黑料入口 —
          <span className="block mt-2 text-primary-300">吃瓜黑料入口最新地址</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-50/80 text-center max-w-2xl leading-relaxed">
          黑料入口首页为你提供吃瓜黑料入口、黑料入口最新地址直达服务，
          覆盖黑料吃瓜在线观看、最新网红塌房现场及热门黑料视频，
          是寻找可靠黑料访问路径的日常承接页。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/hot"
            className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-flashlight-line"></i>
            </div>
            立即吃瓜
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 font-medium rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10 text-xs text-background-50/50">
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-shield-check-line"></i>
            </div>
            安全访问
          </span>
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-refresh-line"></i>
            </div>
            每日更新
          </span>
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-off-line"></i>
            </div>
            隐私保护
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}